export default {
  mobileTiles: [
    {
      company: 'Newsweek',
      height: '118px',
      width: '89px',
      centered: true,
      naturalHeight: 118,
      naturalWidth: 89,
      image:
        'https://www.nerdwallet.com/cdn/company/2023/awards/NW_2023_MLW_US-v2.png',
      customTileStyle: 'grow',
    },
    {
      company: "CNBC World's Top Fintech Companies 2023",
      height: '122px',
      width: '151px',
      centered: true,
      naturalHeight: 151,
      naturalWidth: 96,
      image: 'https://www.nerdwallet.com/cdn/company/2023/awards/badge131.png',
      customTileStyle: 'grow',
    },
    {
      company: 'MIT Black Equity at Work - Bronze Certified',
      height: '122px',
      width: '80px',
      centered: true,
      naturalHeight: 151,
      naturalWidth: 96,
      image: 'https://www.nerdwallet.com/cdn/company/2023/awards/badge128.png',
    },
    {
      company: 'Fair Pay Workplace Certified',
      height: '122px',
      width: '80px',
      centered: true,
      naturalHeight: 151,
      naturalWidth: 96,
      image: 'https://www.nerdwallet.com/cdn/company/2023/awards/badge129.png',
    },
    {
      company: 'RealSimple Smart Money Awards 2023',
      height: '122px',
      width: '151px',
      centered: true,
      naturalHeight: 151,
      naturalWidth: 96,
      image: 'https://www.nerdwallet.com/cdn/company/2023/awards/badge130.png',
    },
    {
      company: "Fortune's Best Medium Workplaces 2023",
      height: '122px',
      width: '60px',
      centered: true,
      naturalHeight: 151,
      naturalWidth: 96,
      image: 'https://www.nerdwallet.com/cdn/company/2023/awards/badge132.png',
      customTileStyle: 'press-logo-columns-6',
    },
    {
      company: "Fortune's Best Workplaces in the Bay Area 2023",
      height: '122px',
      width: '60px',
      centered: true,
      naturalHeight: 151,
      naturalWidth: 96,
      image: 'https://www.nerdwallet.com/cdn/company/2023/awards/badge126.png',
      customTileStyle: 'press-logo-columns-6',
    },
    {
      company:
        "Fortune's Best Workplaces in Financial Services and Insurance 2023",
      height: '122px',
      width: '60px',
      centered: true,
      naturalHeight: 151,
      naturalWidth: 96,
      image: 'https://www.nerdwallet.com/cdn/company/2023/awards/badge133.png',
      customTileStyle: 'press-logo-columns-6',
    },
    {
      company: "Fortune's Best Workplaces for Millennials 2023",
      height: '122px',
      width: '60px',
      centered: true,
      naturalHeight: 151,
      naturalWidth: 96,
      image: 'https://www.nerdwallet.com/cdn/company/2023/awards/badge127.png',
      customTileStyle: 'press-logo-columns-6',
    },
    {
      company: "Fortune's Best Workplaces for Women 2023",
      height: '122px',
      width: '60px',
      centered: true,
      naturalHeight: 170,
      naturalWidth: 95,
      image:
        'https://www.nerdwallet.com/cdn/company/2023/awards/fortune-best-workplace-women-2023.png',
      customTileStyle: 'press-logo-columns-6',
    },
  ],
  topTiles: [
    {
      company: 'Newsweek',
      height: '151px',
      width: '114px',
      centered: true,
      naturalHeight: 151,
      naturalWidth: 114,
      image:
        'https://www.nerdwallet.com/cdn/company/2023/awards/NW_2023_MLW_US-v2.png',
      customTileStyle: 'press-logo-columns-5 wide',
    },
    {
      company: "CNBC World's Top Fintech Companies 2023",
      height: '151px',
      width: '151px',
      naturalHeight: 151,
      naturalWidth: 96,
      image: 'https://www.nerdwallet.com/cdn/company/2023/awards/badge131.png',
    },
    {
      company: 'MIT Black Equity at Work - Bronze Certified',
      height: '151px',
      width: '151px',
      naturalHeight: 151,
      naturalWidth: 96,
      image: 'https://www.nerdwallet.com/cdn/company/2023/awards/badge128.png',
      customTileStyle: 'press-logo-columns-6',
    },
    {
      company: 'Fair Pay Workplace Certified',
      height: '151px',
      width: '151px',
      naturalHeight: 151,
      naturalWidth: 96,
      image: 'https://www.nerdwallet.com/cdn/company/2023/awards/badge129.png',
      customTileStyle: 'press-logo-columns-6',
    },
    {
      company: 'RealSimple Smart Money Awards 2023',
      height: '151px',
      width: '151px',
      naturalHeight: 151,
      naturalWidth: 96,
      image: 'https://www.nerdwallet.com/cdn/company/2023/awards/badge130.png',
    },
  ],
  bottomTiles: [
    {
      company: "Fortune's Best Medium Workplaces 2023",
      height: '173px',
      width: '98px',
      naturalHeight: 170,
      naturalWidth: 95,
      image: 'https://www.nerdwallet.com/cdn/company/2023/awards/badge132.png',
      customTileStyle: 'press-logo-columns-6',
    },
    {
      company: "Fortune's Best Workplaces in the Bay Area 2023",
      height: '173px',
      width: '98px',
      naturalHeight: 170,
      naturalWidth: 95,
      image: 'https://www.nerdwallet.com/cdn/company/2023/awards/badge126.png',
      customTileStyle: 'press-logo-columns-6',
    },
    {
      company:
        "Fortune's Best Workplaces in Financial Services and Insurance 2023",
      height: '173px',
      width: '98px',
      naturalHeight: 170,
      naturalWidth: 95,
      image: 'https://www.nerdwallet.com/cdn/company/2023/awards/badge133.png',
      customTileStyle: 'press-logo-columns-6',
    },
    {
      company: "Fortune's Best Workplaces for Millennials 2023",
      height: '173px',
      width: '98px',
      naturalHeight: 170,
      naturalWidth: 95,
      image: 'https://www.nerdwallet.com/cdn/company/2023/awards/badge127.png',
      customTileStyle: 'press-logo-columns-6',
    },
    {
      company: "Fortune's Best Workplaces for Women 2023",
      height: '173px',
      width: '98px',
      naturalHeight: 170,
      naturalWidth: 95,
      image:
        'https://www.nerdwallet.com/cdn/company/2023/awards/fortune-best-workplace-women-2023.png',
      customTileStyle: 'press-logo-columns-6',
    },
  ],
};
